import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { SharedModule } from '../../../shared/shared.module';
import { CommonModule } from '@angular/common';
import { InventoryService } from '../../../services/inventory.service';
import { MessageService } from 'primeng/api';
import { ProductGroups, UnitsOfMeasure } from '../../../model/administration.model';
import _ from 'lodash';
import { AdministratorService } from '../../../services/administrator.service';
import { gridPageRequest, GSTInfo } from '../../../model/common/common.model';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { GstListLookupComponent } from '../gst-list-lookup/gst-list-lookup.component';

@Component({
  selector: 'app-create-quick-product-lookup',
  standalone: true,
  imports: [SharedModule, CommonModule],
  templateUrl: './create-quick-product-lookup.component.html',
  styleUrl: './create-quick-product-lookup.component.scss'
})
export class CreateQuickProductLookupComponent implements OnInit {
  @Output() productData = new EventEmitter<any>();
  constructor(private inventoryService: InventoryService, private messageService: MessageService,
    private administratorService: AdministratorService, public ref: DynamicDialogRef, public dialogService: DialogService) { }


  ngOnInit(): void {
    this.getProductCodeSetting();
    this.getUOM();
    this.getProductType();
    this.getCatagory();
    this.getProductType();
    this.getCatagory();
    this.getProductGroups();
  }

  submitted: boolean = false;
  loader: boolean = false;

  UOMDropdown: UnitsOfMeasure[] = [];
  filteruom: UnitsOfMeasure[] = [];
  ProductTypeDropdown: any[] = [];
  CategoryDropdown: any[] = [];
  filterCategories: any[] = [];
  filterproducttype: any[] = [];
  filterProductGroups: ProductGroups[] = [];
  ProductGroupsDropdown: ProductGroups[] = [];
  filterCategorys: any[] = [];
  ProductSubCategoryDropdown: any[] = [];
  iseditProduct: boolean = false;
  allHSNCodes: any[] = [];
  filteredHSNCodes: any[] = [];
  pageRequest: gridPageRequest = {
    pageIndex: 0,
    pageSize: 100,
    id: 0
  }

  isAutoProductCodeEnabled = false;
  isConfigLoaded = false;

  createProductForm = new FormGroup({
    ProductName: new FormControl('', Validators.required),
    ProductCode: new FormControl('', [Validators.required, Validators.pattern(/^[a-zA-Z0-9]*$/)]),
    ProductDescription: new FormControl(''),
    ProductImage: new FormControl(),
    // CheckBox
    CanBeSold: new FormControl(false),
    CanBePurchased: new FormControl(false),
    CanBeRented: new FormControl(false),
    isactive: new FormControl(true),
    IsTaxable: new FormControl(true),
    isLotTracking: new FormControl(false),
    IsInventory: new FormControl(true),
    isLocationTracking: new FormControl(false),
    isSerialTracking: new FormControl(false),
    // General Information
    ProductType: new FormControl('', Validators.required),
    producttypedropdown: new FormControl(''),
    UOM: new FormControl(''),
    UnitsofMeasureId: new FormControl(null),
    UnitsOfMeasure: new FormControl('', Validators.required),
    PurchasingUom: new FormControl('EA'),
    SellingUom: new FormControl('EA'),
    SalesPrice: new FormControl(0.00, Validators.required),
    StandardCost: new FormControl(0.00, Validators.required),
    Weight: new FormControl(0),
    CategoryId: new FormControl(0), //Product Category
    CategoryValue: new FormControl(''),
    GSTId: new FormControl(),
    gstRate: new FormControl(),
    HSNCode: new FormControl(),
    Barcode: new FormControl(''),
    CreatedBy: new FormControl(''),
    UpdatedBy: new FormControl(),
    CostCalculation: new FormControl(),
    manualEntry: new FormControl(false),
    Vendor: new FormControl(),
    VendorName: new FormControl(''),
    VendorCode: new FormControl(),
    Add: new FormControl(),
    AddressId: new FormControl(),
    ProductSpecification: new FormControl(),
    ProductSize: new FormControl(),
    VendorId: new FormControl(),
    IsServiceType: new FormControl<boolean | null>(null, Validators.required),
    SubCategoryName: new FormControl(null),
    ProductGroupName: new FormControl(null),
    SubCategoryId: new FormControl<any>(null),
    GroupId: new FormControl<any>(null),
    ProductPrefix: new FormControl(''),
  });

  getProductCodeSetting() {
    this.inventoryService
      .getUnitByAppKey('hide.Product_type')
      .subscribe((res: any) => {

        this.isAutoProductCodeEnabled = res?.data === 'Y';

        this.createProductForm.patchValue({
          manualEntry: false
        });

        if (this.iseditProduct) return;

        this.generateProductCode();
      });
  }

  generateProductCode() {
    if (this.iseditProduct) return;

    if (this.isAutoProductCodeEnabled) {
      this.getManualEntry();
      this.createProductForm.controls.ProductCode.setValue("");
    } else {
      this.getProductCode();
    }
  }

  get formControls() {
    return this.createProductForm.controls;
  }

  createProduct() {

    this.submitted = true;

    const isValid = this.validateForm();
    if (!isValid) {
      return;
    }

    var ProductCode = this.createProductForm.controls.ProductCode.value;
    this.createProductForm.controls.ProductCode.setValue(_.toString(ProductCode));
    this.createProductForm.controls.CreatedBy.setValue(_.toString(localStorage.getItem("username")));

    const value = this.createProductForm.value.IsServiceType;
    this.inventoryService.createProduct(this.createProductForm.value).subscribe({
      next: (data: any) => {
        if (data.success === true) {
          this.messageService.add({ severity: 'success', summary: 'Success', detail: data.message });
          this.getProductById(data.productId);

        } else {
          this.loader = false;
          this.messageService.add({ severity: 'error', summary: 'Failed', detail: data.message });
        }
      },
      error: error => {
        console.log(error);
        this.loader = false;
        this.messageService.add({ severity: 'error', summary: 'Failed', detail: 'Error while Creating Product' });
      }
    });


  }

  getProductById(productId: number) {
    this.inventoryService.getProductById(productId).subscribe({
      next: (data: any) => {
        this.productData.emit(data);
        this.loader = false;
      },
      error: (error) => {
        this.messageService.add({ severity: 'error', summary: 'Failed', detail: 'Error while fetching product data.' });
        console.log(error);
        this.loader = false;
      }
    });
  }

  validateForm() {
    let isValid = true;
    if (this.createProductForm.invalid) {
      this.messageService.add({ severity: 'warn', summary: 'Warning', detail: 'Please fill Required field' })
      isValid = false;
    }

    return isValid;
  }


  checkProductCode() {
    if (!this.createProductForm.controls.ProductCode.value) {
      return;
    }


    this.inventoryService.checkProductCode(this.createProductForm.controls.ProductCode.value).subscribe(
      (data: any) => {
        if (data.success == true) {
          // console.log(data);
        } else {
          this.createProductForm.controls.ProductCode.setValue('');
          this.messageService.add({ severity: 'error', summary: 'Failed', detail: data.message });
          this.createProductForm.controls.manualEntry.setValue(true);
        }
      },
      (error: any) => {
        console.log(error);
      }
    );

  }

  // manualEntry() {
  //   const manualEntryValue = this.createProductForm.controls.manualEntry.value;
  //   this.iseditProduct = false;
  //   if (manualEntryValue === true) {
  //     this.createProductForm.controls.ProductCode.setValue('');
  //   } else {
  //     //this.getProductCode();
  //     this.getManualEntry();
  //   }
  // }

  manualEntry() {
    if (this.iseditProduct) return;

    const isManual = this.createProductForm.controls.manualEntry.value;

    if (isManual) {
      this.createProductForm.controls.ProductCode.reset();
      return;
    }

    this.generateProductCode();
  }

  getManualEntry() {
    //this.loader = true;
    const productType = this.createProductForm.controls['ProductType'].value;
    const productPrefix = this.createProductForm.controls['ProductPrefix'].value ?? '';;

    // if (!productType) {
    //   this.loader = false;
    //   this.messageService.add({
    //     severity: 'error',
    //     summary: 'Error',
    //     detail: 'Product Type is required to generate the Product number.'
    //   });
    //   return;
    // }

    if (!this.createProductForm.controls.manualEntry.value) {
      this.getAutoProductCode(productPrefix);
    }

  }

  // getProductCode() {
  //   this.inventoryService.autogenerateProductCode().subscribe({
  //     next: (data: any) => {
  //       this.createProductForm.controls.ProductCode.setValue(data);
  //     },
  //     error: error => {
  //       console.log(error);
  //     }
  //   });
  // }
  getProductCode() {
    this.inventoryService.autogenerateProductCodeNew().subscribe({
      next: (data: any) => {
        // const alphanumericCode = 'P';
        // const productCode = alphanumericCode + data;
        // this.createProductForm.controls.ProductCode.setValue(productCode);
        this.createProductForm.controls.ProductCode.setValue(data.productCode);
      },
      error: error => {
        console.log(error);
      }
    });
  }

  filterUOM(event: any) {
    let filtered: any[] = [];
    let query = event.query;

    for (let i = 0; i < (this.UOMDropdown as any[]).length; i++) {
      let uom = (this.UOMDropdown as any[])[i];
      if (uom.unitsofMeasureCode.toLowerCase().indexOf(query.toLowerCase()) == 0 ||
        uom.unitsofMeasure.toLowerCase().indexOf(query.toLowerCase()) === 0) {
        filtered.push(uom);
      }
    }

    this.filteruom = filtered;
  }

  setUOM(event: any) {
    if (event.value) {
      this.createProductForm.controls.UnitsofMeasureId.setValue(event.value.unitsofMeasureId);
      this.createProductForm.controls.UnitsOfMeasure.setValue(_.toString(event.value.unitsofMeasure));
      this.createProductForm.controls.SellingUom.setValue(_.toString(event.value.unitsofMeasure));
      this.createProductForm.controls.PurchasingUom.setValue(_.toString(event.value.unitsofMeasure));
    }
  }

  getUOM() {
    this.administratorService.getAllUnitsOfMeasure(this.pageRequest).subscribe({
      next: (data: any) => {
        // console.log(data.unitsofMeasures);
        this.UOMDropdown = data.unitsofMeasures;
      },
      error: error => {
        console.log(error);
      }
    });
  }

  getGSTList() {
    const type = this.createProductForm.get('IsServiceType')?.value;

    if (type === null || type === undefined) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Validation',
        detail: 'Please select Type (Goods or Service) first.'
      });
      return;
    }
    let typeBoolean: boolean;
    if (type === false) {
      typeBoolean = false;
    } else if (type === true) {
      typeBoolean = true;
    } else {
      this.messageService.add({
        severity: 'warn',
        summary: 'Validation',
        detail: 'Please select Type (Goods or Service) first.'
      });
      return;
    }

    this.ref = this.dialogService.open(GstListLookupComponent, {
      header: 'GST List',
      width: '60%',
      data: { type: typeBoolean }
    });

    this.ref.onClose.subscribe((data: GSTInfo) => {
      if (data) {
        this.createProductForm.controls.HSNCode.setValue(data.hsnCode);
        this.createProductForm.controls.GSTId.setValue(_.toNumber(data.gstId));
        const isTaxable = data.gstRate > 0;
        this.createProductForm.controls.IsTaxable.setValue(isTaxable);
        this.createProductForm.controls.gstRate.setValue(data.gstRate);
      }
    });
  }


  getCatagory() {
    this.inventoryService.getCatagory().subscribe({
      next: (data: any) => {
        this.CategoryDropdown = data.category;
      },
      error: error => {
        console.log(error);
      }
    });
  }

  filterCatagory(event: any) {
    let filtered: any[] = [];
    let query = event.query;

    for (let i = 0; i < (this.CategoryDropdown as any[]).length; i++) {
      let productType = (this.CategoryDropdown as any[])[i];
      if (productType.categoryName.toLowerCase().indexOf(query.toLowerCase()) == 0 ||
        productType.categoryCode.toLowerCase().indexOf(query.toLowerCase()) === 0) {
        filtered.push(productType);
      }
    }

    this.filterCategories = filtered;
  }

  setCategory(event: any) {
    if (event.value) {
      const selectedCategoryId = event.value.categoryId;
      this.createProductForm.controls.CategoryId.setValue(selectedCategoryId);
      this.filterProductGroups = this.ProductSubCategoryDropdown.filter(
        (sub: any) => sub.categoryId === selectedCategoryId
      );
    }
  }

  getProductType() {
    this.inventoryService.getProductType().subscribe({
      next: (data: any) => {
        this.ProductTypeDropdown = data.productType;
      },
      error: error => {
        console.log(error);
      }
    });
  }

  // setProductType(data: any) {
  //   if (data.value) {
  //     const productCode = _.toString(data.value.productTypeCode);
  //     this.createProductForm.controls.ProductType.setValue(productCode);
  //     this.getProductTypeNameByCode(productCode);
  //   }
  // }

  // setProductType(data: any) {
  //   if (!data?.value) return;

  //   const productType = data.value;

  //   this.createProductForm.patchValue({
  //     ProductType: productType.productTypeCode,
  //     ProductPrefix: productType.productTypePrefix
  //   });

  //   if (!this.createProductForm.controls.manualEntry.value) {
  //     this.getAutoProductCode(productType.productTypePrefix);
  //   }
  // }

  setProductType(data: any) {
    if (!data?.value) return;

    const productType = data.value;

    this.createProductForm.patchValue({
      ProductType: productType.productTypeCode,
      ProductPrefix: productType.productTypePrefix
    });

    if (!this.createProductForm.controls.manualEntry.value && this.isAutoProductCodeEnabled) {
      this.getAutoProductCode(productType.productTypePrefix);
    }
  }


  getAutoProductCode(prefix: string) {
    //this.loader = true;

    this.inventoryService.getautogenerateProductCodeNext(prefix).subscribe({
      next: (res: any) => {
        this.createProductForm.patchValue({
          ProductCode: res.productCode
        });
      },
      error: () => {
        this.loader = false;
      }
    });
  }

  getProductTypeNameByCode(productTypeCode: string): void {
    if (!productTypeCode) {
      this.createProductForm.controls['producttypedropdown'].setValue('Invalid code');
      return;
    }

    this.inventoryService.getProductByType(productTypeCode).subscribe({
      next: (data: any[]) => {
        if (Array.isArray(data) && data.length > 0) {
          const productType = data[0];
          const name = productType?.productTypeName || 'Unknown';
          this.createProductForm.controls['producttypedropdown'].setValue(name);
        } else {
          this.createProductForm.controls['producttypedropdown'].setValue('Unknown');
        }
      },
      error: (error: any) => {
        console.error('Error fetching product type name:', error);
        this.createProductForm.controls['producttypedropdown'].setValue('Error fetching name');
      }
    });
  }


  filterProductType(event: any) {
    let filtered: any[] = [];
    let query = event.query;

    for (let i = 0; i < (this.ProductTypeDropdown as any[]).length; i++) {
      let productType = (this.ProductTypeDropdown as any[])[i];
      if (productType.productTypeCode.toLowerCase().indexOf(query.toLowerCase()) == 0 ||
        productType.productTypeName.toLowerCase().indexOf(query.toLowerCase()) === 0) {
        filtered.push(productType);
      }
    }

    this.filterproducttype = filtered;
  }

  setProductSubCategory(event: any) {
    if (event.value) {
      this.createProductForm.controls.SubCategoryName.setValue(event.value.subCategoryName);
      this.createProductForm.controls.SubCategoryId.setValue(event.value.subCategoryId);
    }
  }

  filtersCatagory(event: any) {
    const query = event.query.toLowerCase();
    const selectedProductGroupName = this.createProductForm.controls.ProductGroupName.value;

    if (!selectedProductGroupName) {
      this.filterCategorys = [];
      return;
    }

    this.administratorService.getGroupByName(selectedProductGroupName).subscribe((response: any) => {
      const selectedProductGroupId = response?.productGroupId;

      if (!selectedProductGroupId) {
        this.filterCategorys = [];
        return;
      }

      const productGroup = (this.ProductGroupsDropdown as any[]).find(pg => pg.productGroupId === selectedProductGroupId);

      if (!productGroup || !Array.isArray(productGroup.category)) {
        this.filterCategorys = [];
        return;
      }

      this.filterCategorys = productGroup.category.filter((category: any) => {
        return category.categoryName?.toLowerCase().startsWith(query) ||
          category.categoryCode?.toLowerCase().startsWith(query);
      });
    });
  }


  // filterProductGroup(event: any) {
  //   let filtered: any[] = [];
  //   let query = event.query;

  //   for (let i = 0; i < (this.ProductGroupsDropdown as any[]).length; i++) {
  //     let ProductGroups = (this.ProductGroupsDropdown as any[])[i];
  //     if (ProductGroups.productGroupName.toLowerCase().indexOf(query.toLowerCase()) == 0 ||
  //       ProductGroups.ProductGroups.toLowerCase().indexOf(query.toLowerCase()) === 0) {
  //       filtered.push(ProductGroups);
  //     }
  //   }

  //   this.filterProductGroups = filtered;
  // }

  filterProductGroup(event: any) {
    const query = event.query.toLowerCase();

    this.filterProductGroups = this.ProductGroupsDropdown.filter(pg =>
      pg.productGroupName.toLowerCase().includes(query)
    );
  }


  setProductGroups(event: any) {
    if (event?.value?.productGroupName) {
      this.createProductForm.controls.ProductGroupName.setValue(event.value.productGroupName);
      this.createProductForm.controls.GroupId.setValue(event.value.productGroupId);
    }
  }

  focusNextInput(event: Event): void {
    const keyboardEvent = event as KeyboardEvent;
    keyboardEvent.preventDefault(); // Prevent form submission on Enter key press

    const target = keyboardEvent.target as HTMLElement;
    const formElements = Array.from((target.closest('form') as HTMLFormElement).elements) as HTMLElement[];
    const index = formElements.indexOf(target);

    if (index > -1 && index < formElements.length - 1) {
      const nextElement = formElements[index + 1];
      nextElement.focus();
    }
  }

  filterSubCategory(event: any) {
    const query = event.query.toLowerCase();
    const selectedCategoryId = this.createProductForm.controls.CategoryId.value;
    const selectedCategory = this.CategoryDropdown.find(
      (cat: any) => cat.categoryId === selectedCategoryId
    );

    if (!selectedCategory || !selectedCategory.subCategory) {
      this.filterCategorys = [];
      return;
    }

    this.filterCategorys = selectedCategory.subCategory.filter((sub: any) =>
      sub.subCategoryName?.toLowerCase().includes(query) ||
      sub.subCategoryCode?.toLowerCase().includes(query)
    );
  }



  getProductGroups() {
    this.administratorService.getAllProductGroups(this.pageRequest).subscribe({
      next: (data: any) => {
        this.ProductGroupsDropdown = data.productGroups;
      },
      error: error => {
        console.log(error);
      }
    });
  }
onTypeChange() {

  const type = this.createProductForm.get('IsServiceType')?.value;

  if (type === null || type === undefined) return;

  if (type === false) {
    this.filteredHSNCodes = this.allHSNCodes.filter(hsn => hsn.IsService === 0);
  } else {
    this.filteredHSNCodes = this.allHSNCodes.filter(hsn => hsn.IsService === 1);
  }

  const selectedHSN = this.createProductForm.get('HSNCode')?.value;
  if (selectedHSN) {
    const match = this.filteredHSNCodes.find(h => h.HSNCode === selectedHSN);
    if (!match) {
      this.createProductForm.get('HSNCode')?.setValue(null);
    }
  }
}
}
